// extracted by mini-css-extract-plugin
module.exports = {"aircraft_container":"Aircraft_aircraft_container__IVfJg","aircraft_content_container":"Aircraft_aircraft_content_container__iI7uI"};